/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number5SansDark = () => (
	<>
		<path
			fill={'#0D2A5E'}
			d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
		/>
		<path
			fill="white"
			d="M11.39 19.59C12.54 20.77 14.09 21.39 15.85 21.39C17.83 21.39 18.95 20.26 18.95 18.89C18.95 17.36 17.85 16.34 15.95 16.34C14.57 16.34 13.45 16.77 12.45 17.72L9.96996 17.04V7.5H21.44V10.55H13.45V14.73C14.33 13.95 15.68 13.35 17.21 13.35C20.04 13.35 22.57 15.35 22.57 18.73C22.57 22.11 19.92 24.49 15.89 24.49C12.99 24.49 10.88 23.54 9.45996 21.99L11.41 19.59H11.39Z"
		/>
	</>
);

export default Number5SansDark;
